import React from 'react';
import { createPortal } from 'react-dom';
import { renderUiIcon } from '../lib/renderUiIcon';

/**
 * @param {{ open: boolean, onClose: () => void, actions: { id: string, label: string, icon?: string }[], onSelect: (id: string) => void, title?: string, variant?: 'list' | 'circle' }} props
 */
function UserFabSheet({ open, onClose, actions, onSelect, title, variant = 'list' }) {
  const [mounted, setMounted] = React.useState(open && actions.length > 0);
  const [visible, setVisible] = React.useState(open && actions.length > 0);
  const isCircle = variant === 'circle';

  React.useEffect(() => {
    if (open && actions.length > 0) {
      setMounted(true);
      requestAnimationFrame(() => setVisible(true));
      return undefined;
    }
    if (mounted) {
      setVisible(false);
      const timer = window.setTimeout(() => setMounted(false), 240);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [open, actions.length, mounted]);

  if (!mounted || !actions.length) return null;

  return createPortal(
    <div
      className={`mingo-user-fab-sheet${isCircle ? ' mingo-user-fab-sheet--circle' : ''}${visible ? ' mingo-user-fab-sheet--open' : ' mingo-user-fab-sheet--closing'}`}
      role="presentation"
    >
      <button type="button" className="mingo-user-fab-sheet__backdrop" aria-label="close" onClick={onClose} />
      <div className="mingo-user-fab-sheet__panel" role="dialog" aria-modal="true" aria-label={title || 'create'}>
        <div className="mingo-user-fab-sheet__handle" aria-hidden="true" />
        {title ? <p className="mingo-user-fab-sheet__title">{title}</p> : null}
        <ul className="mingo-user-fab-sheet__list">
          {actions.map((item, idx) => (
            <li key={item.id} className={isCircle ? 'mingo-user-fab-sheet__circle-item' : undefined}>
              <button
                type="button"
                className={isCircle ? 'mingo-user-fab-sheet__circle-btn' : 'mingo-user-fab-sheet__row'}
                style={{ '--fab-row-delay': `${visible ? idx * 0.07 : (actions.length - 1 - idx) * 0.05}s` }}
                onClick={() => onSelect(item.id)}
              >
                {item.icon ? (
                  <span
                    className={isCircle ? 'mingo-user-fab-sheet__circle-icon' : 'mingo-user-fab-sheet__icon'}
                    aria-hidden="true"
                  >
                    {renderUiIcon(item.icon, { size: 20 })}
                  </span>
                ) : null}
                <span className={isCircle ? 'mingo-user-fab-sheet__circle-label' : undefined}>{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
        <button type="button" className="mingo-user-fab-sheet__close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>,
    document.body,
  );
}

export default React.memo(UserFabSheet);
